import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingTextService {

  private messages: string[] = [
    'Ponte metas altas y no te detengas hasta llegar allí.',
    'Siempre hay una razón para sonreír. Encuéntrala',
    'Enamórate del proceso de convertirte en la mejor versión de ti.',
    'Puedo y lo haré',
    'No olvides porque empezaste',
    'Las oportunidades no pasan, las creas.',
    'Seas lo que seas, sé de los mejores.',
    'Cree en ti y todo será posible.',
    'La pasión por lo que haces te hará entender que los limites son mentales.',
    'Las oportunidades no suceden, tu las creas.',
    'Cuando piensas positivo, las cosas ocurren.',
    'El camino del éxito es la actitud',
    'Hay algo en ti que el mundo necesita, así que sal a hacer lo que sabes.',
    'Convierte tus sueños en objetivos',
    'Seamos realistas y hagamos lo imposible.',
    'Enamórate de tu existencia',
    'La sabiduría más verdadera es una resuelta determinación.',
    'Una actitud sana es contagiosa, deja que todos se impregnen de ella.',
    'Aspira a ser la persona a la que más admires'
  ];

  public getMessage() {
    const indexMessage = this.getRndInteger(0, this.messages.length);
    let message = this.messages[indexMessage];
    if (message == undefined) {
      message = this.messages[2];
    }
    return message;
  }

  private getRndInteger(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) );
  }
}
